import { mapById } from "~/hooks/useDropdownOptions";
import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect("/teams/organization_teams", {
  displayName: "OrganizationTeamsSelect",
  defaultPlaceholder: "Select a Team...",
  mapOption: mapById,
});
